import { startCheckout } from "./checkout";

// The UpsellFunnelHost (mounted once at the app root) registers itself here.
let host = null;
export function registerUpsellHost(fn) {
  host = fn;
}

// Single entry point for every "buy" action across the site. Opens the upsell
// funnel, then redirects to Stripe with the base product + accepted upsells.
// Falls back to a direct checkout if the host isn't mounted for any reason.
export function launchCheckout(lookupKey, opts = {}) {
  if (typeof host === "function") host(lookupKey, opts);
  else startCheckout(lookupKey, opts);
}
